import { render, staticRenderFns } from "./TechWorks.vue?vue&type=template&id=b7089976"
import script from "./TechWorks.vue?vue&type=script&lang=js"
export * from "./TechWorks.vue?vue&type=script&lang=js"
import style0 from "./TechWorks.vue?vue&type=style&index=0&id=b7089976&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports